import React, { useId } from 'react';

export function LogoMark(props: React.SVGProps<SVGSVGElement>) {
  const id = useId();
  return (
    <svg viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg" data-slot="icon" {...props}>
      <path d="M26.0676 6H9.35754L13.6279 11.3335H23.338L20.2394 15.2038C18.9303 16.8392 18.9303 19.1621 20.2394 20.7975L23.3341 24.6652L12.6672 24.6626L18.718 17.1046H12.0508L6 24.6613V30H26.0676C28.2403 30 30.0013 28.239 30.0013 26.0663V26.0468C30.0013 25.1534 29.697 24.2871 29.1389 23.5892L24.6678 18.0006L29.1389 12.4121C29.697 11.7142 30.0013 10.8479 30.0013 9.95446V9.93504C30.0013 7.76229 28.2403 6.00129 26.0676 6.00129V6Z" fill={`url(#${id})`} />
      <defs>
        <linearGradient id={id} x1="6" y1="30" x2="29.9989" y2="5.99889" gradientUnits="userSpaceOnUse">
          <stop stop-color="#18EDA3" />
          <stop offset="1" stop-color="#18D4ED" />
        </linearGradient>
      </defs>
    </svg>
  );
}
